import CityPage from "../CityPage";

export default function GlenEllyn() {
  return <CityPage slug="glen-ellyn" />;
}
